var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4878 2.0468C21.0122 1.53866 22.4625 2.98895 21.9544 4.51338L16.8978 19.6832C16.3642 21.2841 14.1869 21.4974 13.3527 20.0304L10.3364 14.7258L13.3179 11.7442C13.6108 11.4513 13.6108 10.9764 13.3179 10.6835C13.025 10.3906 12.5502 10.3906 12.2573 10.6835L9.27579 13.665L3.97077 10.6484C2.50383 9.81431 2.7171 7.63704 4.31802 7.1034L19.4878 2.0468Z",
    fill: "#31B7A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendFilled);
export default __webpack_public_path__ + "static/media/send-filled.ffa2ff9d8ddb0f320bd856fa191dcd82.svg";
export { ForwardRef as ReactComponent };